import React, { FC } from 'react';
import styles from './menu.module.css';
import { useLocation } from 'react-router-dom';
import clsx from 'clsx';

const isCurrSite = (currDomain: string) => {
  return window.location.origin === currDomain;
};

const mainDomain = isCurrSite('https://www.ohyagroup.com')
  ? ''
  : process.env.REACT_APP_GROUP_URL || 'https://www.ohyagroup.com';

const energyDomain = isCurrSite('https://www.ohyaenergy.com')
  ? ''
  : process.env.REACT_APP_ENERGY_URL || 'https://www.ohyaenergy.com';

const financeDomain = isCurrSite('https://www.ohyafinance.com')
  ? ''
  : process.env.REACT_APP_FINANCE_URL || 'https://www.ohyafinance.com';

const estateDomain = isCurrSite('https://www.ohyaconst.com')
  ? ''
  : process.env.REACT_APP_CONSTRUCT_URL || 'https://www.ohyaconst.com';

let foodDomain = isCurrSite('https://www.ohyaagtk.com')
  ? ''
  : process.env.REACT_APP_FOOD_URL || 'https://www.ohyaagtk.com';

export const Menu: FC = () => {
  const location = useLocation();
  const navTo = (path: string) => {
    // if (location.pathname + location.search !== path) {
    //   navigate(path);
    // }
    window.location.assign(path);
    const ele = document.getElementById('menuToggle') as HTMLInputElement;
    ele.checked = !ele.checked;
  };
  return (
    <div className="relative">
      <div className={clsx(styles.wrapper)}>
        <div className={clsx(styles.MENU)}>
          <img
            className={clsx(styles['group'])}
            alt="Group"
            src="/assets/images/group.png"
          />
          <div className={clsx(styles.frame)}>
            <div className={styles.div}>
              <div
                className={styles['text-wrapper']}
                onClick={() => navTo(mainDomain + '/')}
              >
                <img alt="Group" src="/assets/images/icon_group_menu.svg" />
              </div>
              <div className={styles.rectangle} />
              <div
                className={clsx(
                  styles['frame-3'],
                  (isCurrSite(
                    process.env.REACT_APP_GROUP_URL ||
                      'https://www.ohyagroup.com'
                  )
                    ? true
                    : window.location.origin === mainDomain) &&
                    location.pathname === '/intro' &&
                    styles['onActive']
                )}
                onClick={() => navTo(mainDomain + '/intro')}
              >
                <div className={clsx(styles['text-wrapper-3'])}>企業理念</div>
              </div>
              <div
                className={clsx(
                  styles['frame-3'],
                  (isCurrSite(
                    process.env.REACT_APP_GROUP_URL ||
                      'https://www.ohyagroup.com'
                  )
                    ? true
                    : window.location.origin === mainDomain) &&
                    location.pathname === '/dev' &&
                    styles['onActive']
                )}
                onClick={() => navTo(mainDomain + '/dev')}
              >
                <div className={styles['text-wrapper-3']}>集團發展</div>
              </div>
            </div>
            <div className={styles.div}>
              <div
                className={styles['text-wrapper']}
                onClick={() => window.open('https://www.ohyamotel.com/')}
              >
                <img alt="Group" src="/assets/images/icon_motel_menu.svg" />
              </div>
              <div className={styles.rectangle} />
              <div
                className={clsx(
                  styles['frame-3'],
                  (isCurrSite(
                    process.env.REACT_APP_GROUP_URL ||
                      'https://www.ohyagroup.com'
                  )
                    ? true
                    : window.location.origin === mainDomain) &&
                    location.pathname === '/hotel/stay' &&
                    location.search === '' &&
                    styles['onActive']
                )}
                // onClick={() => navTo(mainDomain + '/hotel/stay')}
                onClick={() =>
                  window.open(
                    'https://ohyamotel.ezhotel.com.tw/1?_ga=2.56942125.643544140.1766467349-2140841849.1766467349&_gl=1*1mm34mm*_ga*MjE0MDg0MTg0OS4xNzY2NDY3MzQ5*_ga_GHVCBCQSDP*czE3NjY0NjczNDgkbzEkZzAkdDE3NjY0NjczNDgkajYwJGwwJGg2NzczMjI2Mzg.*_ga_K81DQY72JC*czE3NjY0NjczNDgkbzEkZzAkdDE3NjY0NjczNDgkajYwJGwwJGgw'
                  )
                }
              >
                <div className={clsx(styles['text-wrapper-3'])}>預訂住宿</div>
              </div>
              {/* <div
                className={clsx(
                  styles['frame-3'],
                  (isCurrSite(
                    process.env.REACT_APP_GROUP_URL ||
                      'https://www.ohyagroup.com'
                  )
                    ? true
                    : window.location.origin === mainDomain) &&
                    location.pathname === '/hotel/rest' &&
                    location.search === '' &&
                    styles['onActive']
                )}
                onClick={() => navTo(mainDomain + '/hotel/rest')}
              >
                <div className={clsx(styles['text-wrapper-3'])}>預訂休息</div>
              </div> */}
              {/* <div
              className={clsx(
                styles["frame-3"],
                location.pathname === "/hotel/stay" &&
                  location.search === "?tempB=true" &&
                  styles["onActive"]
              )}
              onClick={() => navTo( mainDomain + "/hotel/stay?tempB=true")}
            >
              <div className={clsx(styles["text-wrapper-3"])}>預訂住宿-B</div>
            </div> */}
              {/* <div
              className={clsx(
                styles["frame-3"],
                location.pathname === "/hotel/rest" &&
                  location.search === "?tempB=true" &&
                  styles["onActive"]
              )}
              onClick={() => navTo( mainDomain + "/hotel/rest?tempB=true")}
            >
              <div className={clsx(styles["text-wrapper-3"])}>預訂休息-B</div>
            </div> */}
            </div>
            <div className={styles.div}>
              <div
                className={styles['text-wrapper']}
                onClick={() => navTo(foodDomain + '/')}
              >
                <img alt="Group" src="/assets/images/icon_agritek_menu.svg" />
              </div>
              <div className={styles.rectangle} />
              <div
                className={clsx(
                  styles['frame-3'],
                  (isCurrSite(
                    process.env.REACT_APP_FOOD_URL || 'https://www.ohyaagtk.com'
                  )
                    ? true
                    : window.location.origin === foodDomain) &&
                    location.pathname === '/' &&
                    styles['onActive']
                )}
                onClick={() => navTo(foodDomain + '/')}
              >
                <div className={styles['text-wrapper-3']}>農牧服務介紹</div>
              </div>
              {/* <div className={clsx(styles["frame-3"], styles.noHover)}>
              <div
                className={clsx(
                  styles["text-wrapper-3"],
                  "!text-[color:var(--neutralneutral-400)]"
                )}
              >
                豬隻 &amp; 飼料試算
              </div>
              <div className="inline-flex items-center gap-[4px] px-[8px] py-[2px] rounded-[4px] overflow-hidden border border-solid border-[color:var(--primaryprimary-700)]">
                  <div className="relative w-fit mt-[-1.00px] text-[color:var(--primaryprimary-700)] [font-family:var(--14-h5-font-family)] font-[number:var(--14-h5-font-weight)] text-[length:var(--14-h5-font-size)] tracking-[var(--14-h5-letter-spacing)] leading-[var(--14-h5-line-height)] whitespace-nowrap ">
                    敬請期待
                  </div>
                </div>
            </div> */}
              {/* <div
              className={clsx(
                styles["frame-3"],
                location.pathname === "/info" && styles["onActive"]
              )}
              onClick={() => navTo( foodDomain + "/info")}
            >
              <div className={styles["text-wrapper-3"]}>行情資訊</div>
            </div> */}
              {/* <div className={clsx(styles["frame-3"], styles.noHover)}>
              <div
                className={clsx(
                  styles["text-wrapper-3"],
                  "!text-[color:var(--neutralneutral-400)]"
                )}
              >
                行情資訊
              </div>
              <div className="inline-flex items-center gap-[4px] px-[8px] py-[2px] rounded-[4px] overflow-hidden border border-solid border-[color:var(--primaryprimary-700)]">
                  <div className="relative w-fit mt-[-1.00px] text-[color:var(--primaryprimary-700)] [font-family:var(--14-h5-font-family)] font-[number:var(--14-h5-font-weight)] text-[length:var(--14-h5-font-size)] tracking-[var(--14-h5-letter-spacing)] leading-[var(--14-h5-line-height)] whitespace-nowrap ">
                    敬請期待
                  </div>
                </div>
            </div> */}
            </div>
            <div className={styles.div}>
              <div
                className={styles['text-wrapper']}
                onClick={() => navTo(financeDomain + '/')}
              >
                <img alt="Group" src="/assets/images/icon_finance_menu.svg" />
              </div>
              <div className={styles.rectangle} />
              <div
                className={clsx(
                  styles['frame-3'],
                  (isCurrSite(
                    process.env.REACT_APP_FINANCE_URL ||
                      'https://www.ohyafinance.com'
                  )
                    ? true
                    : window.location.origin === financeDomain) &&
                    location.pathname === '/' &&
                    styles['onActive']
                )}
                onClick={() => navTo(financeDomain + '/')}
              >
                <div className={clsx(styles['text-wrapper-3'])}>貸款申請</div>
              </div>
              {/* <div
                className={clsx(
                  styles['frame-3'],
                  (isCurrSite(
                    process.env.REACT_APP_FINANCE_URL ||
                      'https://www.ohyafinance.com'
                  )
                    ? true
                    : window.location.origin === financeDomain) &&
                    location.pathname === '/aboutus' &&
                    styles['onActive']
                )}
                onClick={() => navTo(financeDomain + '/aboutus')}
              >
                <div className={clsx(styles['text-wrapper-3'])}>關於我們</div>
              </div>

              <div
                className={clsx(
                  styles['frame-3'],
                  (isCurrSite(
                    process.env.REACT_APP_FINANCE_URL ||
                      'https://www.ohyafinance.com'
                  )
                    ? true
                    : window.location.origin === financeDomain) &&
                    location.pathname === '/intro' &&
                    styles['onActive']
                )}
                onClick={() => navTo(financeDomain + '/intro')}
              >
                <div className={clsx(styles['text-wrapper-3'])}>歐悅貸介紹</div>
              </div> */}

              {/* <div
              className={clsx(
                styles["frame-3"],
                location.pathname === "/my-loan" && styles["onActive"]
              )}
              onClick={() => navTo( financeDomain + "/my-loan")}
            >
              <div className={clsx(styles["text-wrapper-3"])}>繳費與查詢</div>
            </div> */}

              {/* <div className={clsx(styles["frame-3"], styles.noHover)}>
                <div
                  className={clsx(
                    styles["text-wrapper-3"],
                    "!text-[color:var(--neutralneutral-400)]"
                  )}
                >
                  繳費與查詢
                </div>
                <div className="inline-flex items-center gap-[4px] px-[8px] py-[2px] rounded-[4px] overflow-hidden border border-solid border-[color:var(--primaryprimary-700)]">
                  <div className="relative w-fit mt-[-1.00px] text-[color:var(--primaryprimary-700)] [font-family:var(--14-h5-font-family)] font-[number:var(--14-h5-font-weight)] text-[length:var(--14-h5-font-size)] tracking-[var(--14-h5-letter-spacing)] leading-[var(--14-h5-line-height)] whitespace-nowrap ">
                    敬請期待
                  </div>
                </div>
              </div> */}
            </div>
            <div className={styles.div}>
              <div
                className={styles['text-wrapper']}
                onClick={() => navTo(energyDomain + '/')}
              >
                <img alt="Group" src="/assets/images/icon_energy_menu.svg" />
              </div>
              <div className={styles.rectangle} />
              <div
                className={clsx(
                  styles['frame-3'],
                  (isCurrSite(
                    process.env.REACT_APP_ENERGY_URL ||
                      'https://www.ohyaenergy.com'
                  )
                    ? true
                    : window.location.origin === energyDomain) &&
                    location.pathname === '/esg' &&
                    styles['onActive']
                )}
                onClick={() => navTo(energyDomain + '/esg')}
              >
                <div className={styles['text-wrapper-3']}>企業社會責任</div>
              </div>
              <div
                className={clsx(
                  styles['frame-3'],
                  (isCurrSite(
                    process.env.REACT_APP_ENERGY_URL ||
                      'https://www.ohyaenergy.com'
                  )
                    ? true
                    : window.location.origin === energyDomain) &&
                    location.pathname === '/service/rental' &&
                    styles['onActive']
                )}
                onClick={() => navTo(energyDomain + '/service/rental')}
              >
                <div className={styles['text-wrapper-3']}>服務項目</div>
              </div>
              <div
                className={clsx(
                  styles['frame-3'],
                  (isCurrSite(
                    process.env.REACT_APP_ENERGY_URL ||
                      'https://www.ohyaenergy.com'
                  )
                    ? true
                    : window.location.origin === energyDomain) &&
                    location.pathname === '/project' &&
                    styles['onActive']
                )}
                onClick={() => navTo(energyDomain + '/project')}
              >
                <div className={styles['text-wrapper-3']}>實績案例</div>
              </div>
            </div>
            <div className={styles.div}>
              <div
                className={styles['text-wrapper']}
                onClick={() => navTo(estateDomain + '/')}
              >
                <img alt="Group" src="/assets/images/icon_const_menu.svg" />
              </div>
              <div className={styles.rectangle} />
              <div
                className={clsx(
                  styles['frame-3'],
                  (isCurrSite(
                    process.env.REACT_APP_CONSTRUCT_URL ||
                      'https://www.ohyaconst.com'
                  )
                    ? true
                    : window.location.origin === estateDomain) &&
                    location.pathname === '/' &&
                    styles['onActive']
                )}
                onClick={() => navTo(estateDomain + '/')}
              >
                <div className={styles['text-wrapper-3']}>歐悅建設介紹</div>
              </div>
              {/* <div className={clsx(styles["frame-3"], styles.noHover)}>
              <div
                className={clsx(
                  styles["text-wrapper-3"],
                  "!text-[color:var(--neutralneutral-400)]"
                )}
              >
                歐悅建設介紹
              </div>
              <div className="inline-flex items-center gap-[4px] px-[8px] py-[2px] rounded-[4px] overflow-hidden border border-solid border-[color:var(--primaryprimary-700)]">
                  <div className="relative w-fit mt-[-1.00px] text-[color:var(--primaryprimary-700)] [font-family:var(--14-h5-font-family)] font-[number:var(--14-h5-font-weight)] text-[length:var(--14-h5-font-size)] tracking-[var(--14-h5-letter-spacing)] leading-[var(--14-h5-line-height)] whitespace-nowrap ">
                    敬請期待
                  </div>
                </div>
            </div> */}
              {/* <div
                className={clsx(
                  styles["frame-3"],
                  window.location.origin === energyDomain && 
                  location.pathname === "/practice" && styles["onActive"]
                )}
                onClick={() => navTo( energyDomain + "/practice")}
              >
                <div className={styles["text-wrapper-3"]}>最新消息</div>
              </div> */}
              {/* <div className={clsx(styles["frame-3"], styles.noHover)}>
              <div
                className={clsx(
                  styles["text-wrapper-3"],
                  "!text-[color:var(--neutralneutral-400)]"
                )}
              >
                最新消息
              </div>
              <div className="inline-flex items-center gap-[4px] px-[8px] py-[2px] rounded-[4px] overflow-hidden border border-solid border-[color:var(--primaryprimary-700)]">
                  <div className="relative w-fit mt-[-1.00px] text-[color:var(--primaryprimary-700)] [font-family:var(--14-h5-font-family)] font-[number:var(--14-h5-font-weight)] text-[length:var(--14-h5-font-size)] tracking-[var(--14-h5-letter-spacing)] leading-[var(--14-h5-line-height)] whitespace-nowrap ">
                    敬請期待
                  </div>
                </div>
            </div> */}
            </div>
          </div>
          {/* <div className="max-w-[1440px] w-full mx-auto">

        </div> */}
        </div>
      </div>
      <div
        className="w-screen h-screen absolute"
        onClick={() => {
          const ele = document.getElementById('menuToggle') as HTMLInputElement;
          ele.checked = !ele.checked;
        }}
      ></div>
    </div>
  );
};
